import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPostcard1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="postcard-1,address"><path d="M6.75 9.75H11.25M6.75 12.75H9.27M2.75 4.75H21.25V19.25H2.75V4.75ZM14.75 9.75H17.25V13.25H14.75V9.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPostcard1;
